import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, param: String, reload: Boolean }

  save() {
    const body = `${this.paramValue}=${encodeURIComponent(this.element.value)}`
    const token = document.querySelector('meta[name=csrf-token]')?.content

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-CSRF-Token': token },
      body
    }).then(() => {
      if (this.reloadValue) Turbo.visit(window.location.href, { action: 'replace' })
    })
  }
}
